import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import clsx from "clsx";
import React from "react";
import { MdChat } from "react-icons/md";
import HeroSubtitle from "../../../components/HeroSubtitle";
import HeroTitle from "../../../components/HeroTitle";
import { globalClasses } from "../../../components/layout/MainLayout/styles";
import { handleNavigate } from "../../../util";
import { AGENDA_HERO_SECTION } from "../../../util/constants";
import { classes, StyledSectionWrapper } from "./styles";

const AgendaHero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <StyledSectionWrapper
      padding="normal"
      isMobile={isMobile}
      sectionId={AGENDA_HERO_SECTION}
      className={globalClasses.iaGradient}
    >
      <div className={classes.background}>
        <Container>
          <Grid
            item
            sm={12}
            md={6}
            justifyContent={isMobile ? "center" : "flex-start"}
            container
            direction="column"
          >
            <HeroTitle>Innovance Agenda</HeroTitle>
            <HeroSubtitle>
              Une solution de suivi des temps spécialisée pour les associations
            </HeroSubtitle>
            <div
              className={clsx(classes.actions, {
                [classes.xsActions]: isXs,
              })}
            >
              <Button
                startIcon={<MdChat />}
                onClick={() => handleNavigate("/contact")}
                size={isMobile ? "medium" : "large"}
                className={classes.button}
                aria-label="Prendre contact"
              >
                Demander une démo
              </Button>
            </div>
          </Grid>
        </Container>
      </div>
    </StyledSectionWrapper>
  );
};

export default AgendaHero;
